import React from "react";
import { withRouter,Redirect  } from "react-router-dom";
import { Nav,Container,Row,Col,Tab,Table,Card,Button,Navbar,NavDropdown,Form,Stack,ListGroup,FormControl,InputGroup,Badge,Spinner } from 'react-bootstrap';
import { BiPrinter } from "react-icons/bi"; 
import { AiOutlineCheck } from "react-icons/ai"; 
import CurrencyInput from 'react-currency-input-field';
import axios from "axios";
import Cookies from 'universal-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import { renderToString } from "react-dom/server";
import qrcode from "qrcode";
import Swal from "sweetalert2";
import AsyncSelect from 'react-select/async';
import Nav_bar from "./Nav_bar";
import Menu from "./Menu";



class Affectation extends React.Component {
  constructor(props)
{
     super(props);
     this.state = {
         
         Numero_de_serie__c: '',
         liste_produit: '',
         Emplacement: '',
         opportunite_id: '',
         opportunite_name: '',
         produit: '',
         produit_non_repertorier: [],
         produit_non_repertorirer_found: [],
         pdf_base64: '',
         compte_array: '',
         compte_array1: '',
         Value: '',
         selectedValue: '',
         option: [],
         id_pdf: '',
         id_pdf_created: '',
         pdf_generated: '',
         loading: '',
         id_devis: ''

     }
}
  componentDidMount()
  {
    const cookies = new Cookies();
    let token =  cookies.get('sf_access_token');
      if(!token)
      {
        window.location.href = window.location.origin+"/oauth/login.php";
      }
      else
      {
       
      }
    

      
  }
  get_opportunite() 
  { 
 

    if(this.state.Numero_de_serie__c === "")
    {
        Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: "Aucune opportunité n'a été trouvé avec ces critères."
             
          })
    }
    else
    {
    const cookies = new Cookies();
    let token =  cookies.get('sf_access_token');
 
    
    const baseURL = cookies.get('sf_instance_url')+"/services/data/v52.0/query/?q=SELECT%20FIELDS%28ALL%29%20FROM%20Opportunity%20WHERE%20Identifiant__c%20%3D%20%27"+this.state.Numero_de_serie__c+"%27%20limit%201"
    

     const config = {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-type': 'application/json'
        },
        data:{}
       }
       this.setState({ loading: true }, () => {
        axios.get(baseURL,  config)
        .then((response) => {
          this.setState({
            loading: false});
        
          
          let array = [];
          let array_msg = [];
            if(response.status == 200)
            {
                if(response.data.totalSize > 0)
                {
                    console.log(response.data.records);
                    this.setState({opportunite_id: response.data.records[0].Id,opportunite_name: response.data.records[0].Name,id_devis: response.data.records[0].SBQQ__PrimaryQuote__c},function(){
                      this.get_opportunite_produit();
                    });
                   

                }
                else
                {
                  this.setState({opportunite_id: '',opportunite_name: '',id_devis: ''},function(){
                    
                  });
                  Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: "Aucune opportunité n'a été trouvé avec ces critères."
                     
                  })
                }
            
                 
               this.forceUpdate();
               
            }
             
          })
          .catch(error => {
             
         });
        });
        }


  }
  get_opportunite_produit(param) 
  { 
 
    const cookies = new Cookies();
    let token =  cookies.get('sf_access_token');
 
    
      const baseURL = cookies.get('sf_instance_url')+"/services/data/v52.0/sobjects/SBQQ__Quote__c/"+this.state.id_devis+"/SBQQ__LineItems__r";
      

     const config = {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-type': 'application/json'
        },
        data:{}
       }
       
        axios.get(baseURL,  config)
        .then((response) => {
          
        
          
          let array = [];
          let array_msg = [];
            if(response.status == 200)
            {
                if(response.data.totalSize > 0)
                {
                    console.log(response.data);
                    this.setState({liste_produit: response.data.records})

                }
                else
                {
                    
                }
            
                 
               this.forceUpdate();
               
            }
             
          })
          .catch(error => {
             
         });




  }
 
  create_rapport_pdf()
  {
    this.setState({pdf_generated: true});
    const doc = new jsPDF();
    
    let array = [];
    let array_1 = [];
    Object.keys(this.state.liste_produit).forEach(key => {
      if(this.state.liste_produit[key].badge)
      {
        var a = [this.state.liste_produit[key].SBQQ__ProductName__c,'','l'];
      }
      else
      {
        var a = [this.state.liste_produit[key].SBQQ__ProductName__c,'',''];
      }
     
      array.push(a);
   //   array.push(['Produit','','']);
    });
    Object.keys(this.state.produit_non_repertorier).forEach(key => {
    console.log(this.state.produit_non_repertorier[key]);
    let a = [this.state.produit_non_repertorier[key].name,'','l'];
    array_1.push(a);
    });
    doc.text(10, 10, "Opportunité : "+this.state.opportunite_name); 
    doc.autoTable({
        head: [['Matériel présent dans le devis','','']],
        body: array,
        margin: {top: 15},
          
        
        didDrawCell: function(data,cell) {
       
          if (data.column.index === 2 && data.cell.section === 'body') {
            if(data.row.raw[2] == "l")
            {
          
              data.cell.styles.fontSize= 1;
              data.cell.styles.halign = "right"
              data.cell.styles.fontStyle = "bold";
              
                       data.cell.styles.textColor = [255,255,255];
              var td = data.cell.raw;
              var img = "data:image/png;base64,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";
      
              var dim = data.cell.height - data.cell.padding('vertical');
              console.log(data.cell.x);
              var textPos = data.cell.textPos;
              doc.addImage(img, data.cell.x,  data.cell.y+2, dim, dim);
              
              
            }
            else
            {
              
              data.cell.styles.fontSize= 1;
              data.cell.styles.fontStyle = "bold";
                       data.cell.styles.textColor = [255,255,255];
              var td = data.cell.raw;
              var img ="data:image/png;base64,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";
          
              var dim = data.cell.height - data.cell.padding('vertical');
              console.log(data.cell.x);
              var textPos = data.cell.textPos;
              doc.addImage(img, data.cell.x,  data.cell.y+1, dim, dim);
              
            }

             
          }
        },
       
      })  
     // doc.text("Objets non répertoriés", 10, doc.autoTable.previous.finalY + 10);
      if(true)
      {
        doc.autoTable({
          head: [['Matériel supplémentaire / de remplacement','','']],
          body: array_1,
          margin: {top: 50}
            
          ,
          didDrawCell: function(data,cell) {
            if (data.column.index === 2 && data.cell.section === 'body') {
              if(data.row.raw[2] == "l")
              {
                console.log(data.cell.styles.fontSize);
                data.cell.styles.fontSize= 1;
                data.cell.styles.halign = "right"
                data.cell.styles.fontStyle = "bold";
                console.log(data.cell.styles.fontSize);
                         data.cell.styles.textColor = [255,255,255];
                var td = data.cell.raw;
                var img = "data:image/png;base64,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";
                console.log(img);
                var dim = data.cell.height - data.cell.padding('vertical');
                console.log(data.cell.x);
                var textPos = data.cell.textPos;
                doc.addImage(img, data.cell.x,  data.cell.y+2, dim, dim);
                
                
              }
              else
              {
                console.log(data.cell.styles.fontSize);
                data.cell.styles.fontSize= 1;
                data.cell.styles.fontStyle = "bold";
                         data.cell.styles.textColor = [255,255,255];
                var td = data.cell.raw;
                var img ="data:image/png;base64,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";
                console.log(img);
                var dim = data.cell.height - data.cell.padding('vertical');
                console.log(data.cell.x);
                var textPos = data.cell.textPos;
                doc.addImage(img, data.cell.x,  data.cell.y+1, dim, dim);
                
              }
  
               
            }
          },
          

        }) 
      }
      
      

      var out = doc.output();
      var url = btoa(out);
      this.setState({pdf_base64: url});
      doc.output('pdfobjectnewwindow'); 
  }
  move_pdf()
  {
    const cookies = new Cookies();
    let token =  cookies.get('sf_access_token');
    const baseURL = cookies.get('sf_instance_url')+"/services/data/v52.0/sobjects/ContentDocumentLink";
    axios.post(baseURL, {
      ContentDocumentId: this.state.id_pdf,
      LinkedEntityId: this.state.opportunite_id,
      visibility: "AllUsers"
     },
     {
       headers: {
        'Authorization': `Bearer ${token}`,
        'Content-type': 'application/json'
       }
    }).then((response) => {
      console.log(response);
      if(response.status == 201)
      {
        toast.success('Le fichier a été envoyé avec succès', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }
    });
  }
  get_pdf_id()
  {
    const cookies = new Cookies();
    let token =  cookies.get('sf_access_token');
    let id_doc = this.state.id_pdf_created;
    const baseURL = cookies.get('sf_instance_url')+"/services/data/v52.0/query/?q=SELECT%20Id%2C%20ContentDocumentId%20FROM%20ContentVersion%20WHERE%20Id%20%3D%20%27"+id_doc+"%27"


let config = {
headers: {
'Authorization': `Bearer ${token}`,
'Content-type': 'application/json'
},
data:{}
} 

axios.get(baseURL,  config)
.then((response) => {
if(response.status == 200)
{
if(response.data.totalSize > 0)
{
  let id_pdf = response.data.records[0].ContentDocumentId;
  this.setState({id_pdf: id_pdf}, function(){
    this.move_pdf();
  });
  

}
else
{
    
}
}
else
{
Swal.fire({
icon: 'error',
title: 'Erreur',
text: 'Fichier introuvable',
 
})
}

})
.catch(error => {

});

}
  upload_file()
  {
    const cookies = new Cookies();
    let token =  cookies.get('sf_access_token');
    let id_user = cookies.get('sf_id').substring(cookies.get('sf_id').lastIndexOf("/")+1);
     
    
      if(this.state.pdf_base64 !== "")
      {
        const baseURL = cookies.get('sf_instance_url')+"/services/data/v52.0/sobjects/ContentVersion"
    
      console.log()
      axios.post(baseURL, {
                Title: this.state.Numero_de_serie__c,
                PathOnClient:  this.state.Numero_de_serie__c+".pdf",
                ContentLocation: "S",
                OwnerId: id_user,
                VersionData: this.state.pdf_base64
               },
               {
                 headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-type': 'application/json'
                 }
              }).then((response) => {
                  if(response.status == 201)
                  {
                    this.setState({id_pdf_created: response.data.id}, function(){
                      this.get_pdf_id();
                    })
               

                  }
                  else
                  {
                    Swal.fire({
                      icon: 'error',
                      title: 'Erreur',
                      text: 'Erreur fichier',
                       
                    })
                  }
                  });
      
              
         
      
      }
  }
  set_class_btn()
  {
      if(this.state.Numero_de_serie__c === "" || this.state.selectedValue === "")
      {
          return "disabled"
      }
      
  }
 
 
  get_product2_name()
  {
    const cookies = new Cookies();
    let token =  cookies.get('sf_access_token');
    const baseURL = cookies.get('sf_instance_url')+"/services/data/v52.0/query/?q=SELECT%20Id%2C%20Product2Id%20FROM%20Asset%20WHERE%20Name%20%3D%20%27"+this.state.produit+"%27"
    const config = {
      headers: {
          'Authorization': `Bearer ${token}`,
          'Content-type': 'application/json'
      },
      data:{}
     }
     
      axios.get(baseURL,  config)
      .then((response) => {
        if(response.status == 200)
        {
        if(response.data.totalSize > 0)
        {
          let id = response.data.records[0].Product2Id;
          const baseURL = cookies.get('sf_instance_url')+"/services/data/v52.0/sobjects/Product2/"+id;
          axios.get(baseURL,  config)
          .then((response) => {
            if(response.status == 200)
            {
              this.badge_check(response.data);

            }
          });
        }
        }
        else
        {
          Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: "Aucun actif n'a été trouvé avec ces critères."
             
          })
        }
      });

  }
  badge_check(param)
  {

      let val = false;
    Object.keys(this.state.liste_produit).forEach(key => {
        console.log(this.state.liste_produit[key].SBQQ__ProductCode__c);
        console.log(this.state.produit);
        if(param.ProductCode === this.state.liste_produit[key].SBQQ__ProductCode__c)
        {
            console.log("found");
            this.state.liste_produit[key].badge = <Badge bg="success" pill><AiOutlineCheck/></Badge>;
            this.forceUpdate();
            val = true;
        }
         
    
});  
if(!val)
{
  
              //  this.get_produit();
                const cookies = new Cookies();
                let token =  cookies.get('sf_access_token');
                const config = {
                  headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-type': 'application/json'
                  },
                  data:{}
                 }
                 const baseURL = cookies.get('sf_instance_url')+"/services/data/v52.0/sobjects/Product2/"+param.Id;
                  axios.get(baseURL,  config)
                  .then((response) => {
                    if(response.status == 200)
                    {
                      if(response.data.errorCode)
                      {
                        Swal.fire({
                          icon: 'error',
                          title: 'Erreur',
                          text: "Aucun actif n'a été trouvé avec ces critères."
                           
                        })
                      }
                      else
                      {
                        let array = [];
                        array.push({name: response.data.Name,id: response.data.Id});
                        this.setState({produit_non_repertorier: array}, function(){
                          this.forceUpdate();
                        });
                      }
                    }
                    else
                    {
                      Swal.fire({
                        icon: 'error',
                        title: 'Erreur',
                        text: "Aucun actif n'a été trouvé avec ces critères."
                         
                      })
                    }
                  });
        
              
}
  }
  liste_produit_opportunite()
  {

    
   // const listItems = obj.produit.map((d) => <ListGroup.Item key={d.name}>{d}</ListGroup.Item>);
   

      if(this.state.opportunite_id !== "" && this.state.opportunite_name !== "")
      {
        let array = [];
        let array1 = [];
        Object.keys(this.state.liste_produit).forEach(key => {
            if(this.state.liste_produit[key].SBQQ__ProductFamily__c === "Matériel")
            {
                array.push(<ListGroup.Item  as="li"
                className="d-flex justify-content-between align-items-start" key={this.state.liste_produit[key].SBQQ__ProductCode__c}>{this.state.liste_produit[key].SBQQ__ProductName__c} {this.state.liste_produit[key].badge}</ListGroup.Item>)
             
            } 
            
        });
        console.log(this.state.produit_non_repertorier);
        Object.keys(this.state.produit_non_repertorier).forEach(key => {
           console.log(this.state.produit_non_repertorier[key])
           array1.push(<ListGroup.Item  as="li"
           className="d-flex justify-content-between align-items-start" key={this.state.produit_non_repertorier[key].id}>{this.state.produit_non_repertorier[key].name}</ListGroup.Item>)
        });
       
          return(<><Form.Label>Titre : </Form.Label><Form.Control type="text" value={this.state.opportunite_name}  /><Container>
              <br/>
          <Row> <Col><Card>
  <Card.Header>Matériel présent dans le devis</Card.Header><ListGroup>{array}</ListGroup></Card></Col><Col><Card>
  <Card.Header>Matériel supplémentaire / de remplacement</Card.Header><ListGroup>{array1}</ListGroup></Card></Col></Row></Container>
  <br/>
  <Form.Label> N° Actif :</Form.Label>
  <InputGroup className="mb-3">
  <Form.Control type="text" placeholder="" value={this.state.produit} onChange={e => this.setState({produit: e.target.value})}/>

    <Button onClick={() => { this.get_product2_name() }}  variant="outline-secondary" id="button-addon2" disabled={this.get_valid()}>
      Valider
    </Button>
  </InputGroup>
{this.affiche_btn()}
  
  </>);
      }
  }
  affiche_btn()
  {
    if(this.state.pdf_generated != "")
    {
      return( <Stack direction="horizontal" gap={3}>
      <Button  className="ms-auto" onClick={() => { this.create_rapport_pdf() }} variant="outline-secondary" id="button-addon2">
      Générer PDF
        </Button> 
        <Button  onClick={() => { this.upload_file() }} variant="outline-secondary" id="button-addon2">
      Envoyer PDF
        </Button>
      </Stack>)
    }
    else
    {
      return( <Stack direction="horizontal" gap={3}>
      <Button  className="ms-auto" onClick={() => { this.create_rapport_pdf() }} variant="outline-secondary" id="button-addon2">
      Générer PDF
        </Button>
      </Stack>)
    }
  }
  raz()
  {
    this.setState({Emplacement: '',Numero_de_serie__c: ''});
  }
  get_valid()
  {
    if(this.state.produit === "")
    {
      return "disabled";
    }
  }
  get_pdf_bouton()
  {
    if(this.state.pdf_generated === "")
    {
      return "none";
    }
  }
  render()
  {
 
     return( <div class="wrapper"><Nav_bar/><Menu/>   <div class="content-wrapper">
     <section class="content" style={{padding: "15px"}}> <Card> <Card.Header> <Stack direction="horizontal" gap={3}>
  <div className="">Vérification avant départ</div>
 
 
</Stack></Card.Header>
  <Card.Body>
    
   
  


   

  <Form.Group className="mb-3" controlId="formBasicPassword">
    <Form.Label> N° Opportunité :</Form.Label>
  <InputGroup className="mb-3">
  <Form.Control type="text" placeholder="" value={this.state.Numero_de_serie__c} onChange={e => this.setState({Numero_de_serie__c: e.target.value})}/>

    <Button onClick={() => { this.get_opportunite() }}  variant="outline-secondary" id="button-addon2">
      Rechercher
    </Button>
  </InputGroup>
  </Form.Group>

  

 
<ToastContainer />
{this.state.loading ? <Spinner animation="border" /> : this.liste_produit_opportunite()}


 
</Card.Body>

   </Card>
 
   </section></div></div>
  
   )
  }
    
   
}
export default withRouter(Affectation);